import {
  APPLY_ADMISSION_REQUEST,
  APPLY_ADMISSION_SUCCESS,
  APPLY_ADMISSION_FAIL,
  GET_ALL_ADMISSIONS_REQUEST,
  GET_ALL_ADMISSIONS_SUCCESS,
  GET_ALL_ADMISSIONS_FAIL,
  UPDATE_ADMISSION_STATUS_REQUEST,
  UPDATE_ADMISSION_STATUS_SUCCESS,
  UPDATE_ADMISSION_STATUS_FAIL,
  UPDATE_ADMISSION_DETAILS_REQUEST,
  UPDATE_ADMISSION_DETAILS_SUCCESS,
  UPDATE_ADMISSION_DETAILS_FAIL,
  DELETE_ADMISSION_REQUEST,
  DELETE_ADMISSION_SUCCESS,
  DELETE_ADMISSION_FAIL,
  CLEAR_ERRORS,
} from "../../constants/admin/admissionConstants";

const initialState = {
  admissions: [],
  loading: false,
  error: null,
  success: false,
};

export const admissionReducer = (state = initialState, action) => {
  switch (action.type) {
    case APPLY_ADMISSION_REQUEST:
    case GET_ALL_ADMISSIONS_REQUEST:
    case UPDATE_ADMISSION_STATUS_REQUEST:
    case UPDATE_ADMISSION_DETAILS_REQUEST:
    case DELETE_ADMISSION_REQUEST:
      return { ...state, loading: true };

    case APPLY_ADMISSION_SUCCESS:
      return { ...state, loading: false, success: true };

    case GET_ALL_ADMISSIONS_SUCCESS:
      return { ...state, loading: false, admissions: action.payload };

    case UPDATE_ADMISSION_STATUS_SUCCESS:
      return {
        ...state,
        loading: false,
        admissions: state.admissions.map((admission) =>
          admission._id === action.payload._id ? action.payload : admission
        ),
      };

    case UPDATE_ADMISSION_DETAILS_SUCCESS:
      return {
        ...state,
        loading: false,
        admissions: state.admissions.map((admission) =>
          admission._id === action.payload._id ? action.payload : admission
        ),
        success: true,
      };

    case DELETE_ADMISSION_SUCCESS:
      return {
        ...state,
        loading: false,
        admissions: state.admissions.filter(
          (admission) => admission._id !== action.payload._id
        ),
      };

    case APPLY_ADMISSION_FAIL:
    case GET_ALL_ADMISSIONS_FAIL:
    case UPDATE_ADMISSION_STATUS_FAIL:
    case UPDATE_ADMISSION_DETAILS_FAIL:
    case DELETE_ADMISSION_FAIL:
      return { ...state, loading: false, error: action.payload };

    case CLEAR_ERRORS:
      return {
        ...state,
        error: null,
      };

    default:
      return state;
  }
};
